<mat-card class="widget-card">
    <mat-card-header>
      <mat-card-title>{{expensesAmount | currency}}</mat-card-title>
      <mat-card-subtitle>Expenses (12 months)</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
    </mat-card-content>
  </mat-card>